
import Select, { SelectProps } from './Select';

type CommonRequestMonthSelectProps = Omit<SelectProps<string>, 'options'>;

const CommonRequestsMonthSelect = ({ selected, onChange, ...selectProps }: CommonRequestMonthSelectProps) => {



  return (
    <Select
      {...selectProps}
      placeholder={`Luna`}
      options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map(((month: number) => ({ key: month.toString(), value: month.toString() })))}
      onChange={onChange}
      selected={selected}
    />
  );
};

export default CommonRequestsMonthSelect;
